/**
 * AutoImporting components
 * @param path
 * @returns {function(): *}
 */
const page = path => () => import(/* webpackChunkName: '' */ `./components/${path}`).then(m => m.default || m)

export const routes = [
    {
        path: '/premium',
        name: 'Premium',
        component: page('PremiumList'),
    },
    {
        path: '/premia/:id',
        name: 'Show Premium',
        component: page('PremiumView'),
        hidden: true
    }
]
